var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr','text-align':'right'})},[(!!this.params.data.author_type)?_c('vs-button',{staticClass:"mt-1 ml-4",on:{"click":function($event){return _vm.showRecord()}}},[_vm._v("詳細 ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }